var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "identify-customer-container" }, [
    _c("div", { staticClass: "identify-content" }, [
      _c("div", { staticClass: "logo-container" }, [
        _c("div", { staticClass: "logo-icon" }, [
          _c("img", {
            staticStyle: { "border-radius": "20px" },
            attrs: {
              src: require("@/assets/images/logo/echope_small.png"),
              width: "150px",
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "text-container" }, [
        _c("img", {
          staticClass: "ticket-icon ticket-icon-top",
          attrs: {
            src: require("@/assets/images/icons/voucher_ticket.png"),
            alt: "",
          },
        }),
        _vm._m(0),
        _c("img", {
          staticClass: "ticket-icon ticket-icon-bottom",
          attrs: {
            src: require("@/assets/images/icons/voucher_ticket.png"),
            alt: "",
          },
        }),
      ]),
      _c("div", { staticClass: "input-container" }, [
        _c("div", { staticClass: "cpf-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.cpf,
                expression: "cpf",
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: "###.###.###-##",
                expression: "'###.###.###-##'",
              },
            ],
            staticClass: "cpf-field",
            class: { invalid: _vm.showInvalidCpfMessage },
            attrs: {
              id: "clientDocument",
              type: "text",
              placeholder: "Clique para informar o CPF",
              maxlength: "14",
              autocomplete: "off",
            },
            domProps: { value: _vm.cpf },
            on: {
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.cpf = $event.target.value
                },
                _vm.onCpfInput,
              ],
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onContinue($event)
              },
            },
          }),
          _vm.showInvalidCpfMessage
            ? _c("div", { staticClass: "invalid-cpf-message" }, [
                _vm._v(" " + _vm._s(_vm.$t("CPF inválido")) + " "),
              ])
            : _vm._e(),
        ]),
        _vm.continueVisible
          ? _c(
              "button",
              {
                staticClass: "continue-btn",
                class: { enabled: _vm.isValidCpf },
                attrs: { disabled: !_vm.isValidCpf },
                on: { click: _vm.onContinue },
              },
              [_vm._v(" Continuar ")]
            )
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "footer-container" }, [
      _c("div", { staticClass: "qrcode-container" }, [
        _c("img", {
          staticClass: "qrcode-image",
          attrs: {
            src: require("@/assets/images/logo/qrcode_ecashback.png"),
            alt: "QR Code eCashback",
          },
        }),
        _vm._m(1),
      ]),
      _c("button", { staticClass: "skip-btn", on: { click: _vm.onSkip } }, [
        _vm._v(" Não quero participar "),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "promo-title" }, [
      _vm._v(" DIGITE"),
      _c("br"),
      _vm._v(" SEU CPF E"),
      _c("br"),
      _c("span", { staticClass: "highlight" }, [
        _vm._v("CONCORRA"),
        _c("br"),
        _vm._v("A CUPONS"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "qrcode-text" }, [
      _c("strong", [_vm._v("Caso não tenha uma conta no app,")]),
      _c("br"),
      _vm._v(" escaneie o QR Code e crie sua conta. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }